import { callRpc } from "@/lib/supabase-rpc";
import { PARENTAL_CONSENT_TEXT, PARENTAL_CONSENT_VERSION } from "@/lib/batch-a/age";

const STORAGE_KEY = "fanjago.pendingParentalConsent";

export type PendingConsent = {
  subjectUserId: string;
  guardianName: string;
  guardianEmail: string;
  relationship: string;
};

export function rememberPendingConsent(consent: PendingConsent) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
}

export async function flushPendingConsent(signedInUserId: string) {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return;
  let pending: PendingConsent;
  try {
    pending = JSON.parse(raw) as PendingConsent;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  if (pending.subjectUserId !== signedInUserId) return;
  const { error } = await callRpc("record_parental_consent", {
    p_subject: pending.subjectUserId,
    p_guardian_name: pending.guardianName,
    p_guardian_email: pending.guardianEmail,
    p_relationship: pending.relationship || "parent",
    p_consent_version: PARENTAL_CONSENT_VERSION,
    p_consent_text: PARENTAL_CONSENT_TEXT.en,
    p_purpose: "account",
  });
  if (!error) sessionStorage.removeItem(STORAGE_KEY);
}
